import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import Button from './ui/Button';

const links = [
  { label: 'Home', to: '/home' },
  { label: 'About', to: '/about' },
  { label: 'Login', to: '/login' },
];

function Navbar() {
  const [open, setOpen] = useState(false);

  const navLinkClass = ({ isActive }) =>
    [
      'rounded-full px-4 py-2 text-sm font-medium transition',
      isActive
        ? 'bg-gradient-to-r from-blue-600 to-teal-500 text-white shadow-sm shadow-blue-900/15'
        : 'text-slate-600 hover:bg-blue-50 hover:text-blue-700',
    ].join(' ');

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-slate-200/70 bg-white/85 backdrop-blur-xl">
      <div className="h-1 color-strip" />
      <nav className="container-page flex h-20 items-center justify-between" aria-label="Main navigation">
        <NavLink to="/home" className="focus-ring flex min-w-0 items-center gap-3 rounded-xl sm:gap-4">
          <BrandLogo className="h-12 w-12 shrink-0 rounded-xl shadow-lg shadow-blue-900/10 sm:h-14 sm:w-14" />
          <div className="min-w-0">
            <p className="brand-wordmark truncate text-2xl text-slate-950 sm:text-3xl">
              Clear Horizons
            </p>
            <p className="hidden text-[0.68rem] font-semibold uppercase tracking-[0.2em] text-blue-600 sm:block">
              Inclusive talent platform
            </p>
          </div>
        </NavLink>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} className={navLinkClass}>
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden md:block">
          <Button to="/home" state={{ scrollToBottom: true }} variant="color" size="sm">
            Contact us
          </Button>
        </div>

        <button
          type="button"
          className="focus-ring inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 md:hidden"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-slate-200 bg-white/95 px-4 py-4 shadow-lg shadow-slate-950/5 md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-2">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={navLinkClass}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </NavLink>
            ))}
            <Button
              to="/home"
              state={{ scrollToBottom: true }}
              variant="color"
              className="mt-2 w-full"
              onClick={() => setOpen(false)}
            >
              Contact us
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}

export default Navbar;
